import { http } from '@/services'

export const workforceService = {
    getWorkforce: (id) => {
        let url = 'workforce';
        if (id) url += '/' + id;

        return http.get(url)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setWorkforce: (employee) => {
        return http.post('workforce/' + employee.id, employee)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    deleteWorkforce: (employee) => {
        return http.delete('workforce/' + employee.id)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getWorkforceMap: () => {
        return http.get('workforce/map')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getRole: () => {
        return http.get('workforce/role')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    setRole: (role) => {
        return http.put('workforce/role', role)
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    },
    getRoleMap: () => {
        return http.get('workforce/role/map')
            .then(response => {
                return response.data;
            }, error => {
                return Promise.reject(error && error.response ? error.response : error);
            });
    }
}